import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {reduxForm} from "redux-form";
import {Element} from "react-scroll";
import Container from "../Container";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Card from "./Card";
import FirstQuestion from "../Questions/FirstQuestion";
import SecondQuestion from "../Questions/SecondQuestion";
import FourthQuestion from "../Questions/FourthQuestion";
import ThirdQuestion from "../Questions/ThirdQuestion";
import Navigation from "../Navigation";
import {getResults} from "../../ducks/results";
import {navigationSelector} from "../../ducks/navigation";

function Cards(props) {
  const {navigation} = props;
  const getCurrentCard = (number) => {
    switch (number) {
      case 0:
        return (
          <Card
            number={1}
            height="auto"
            backgroundColor="#fcefeb"
            color="#d3463d"
          >
            <FirstQuestion />
          </Card>
        );

      case 1:
        return (
          <Card
            number={2}
            height="auto"
            backgroundColor="#dceff1"
            color="#4089a1"
          >
            <SecondQuestion />
          </Card>
        );

      case 2:
        return (
          <Card
            number={3}
            height="auto"
            backgroundColor="#f4fceb"
            color="#79a942"
          >
            <ThirdQuestion />
          </Card>
        );

      case 3:
        return (
          <Card
            number={4}
            height="auto"
            backgroundColor="#fdf9ea"
            color="#f6b47e"
            numberDirection="left"
          >
            <FourthQuestion />
          </Card>
        );
    }
    return void 0;
  };
  return (
    <Grid container>
      <Container>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            props.getResults();
          }}
        >
          <Hidden mdUp>
            <Grid item xs={12}>
              {/* only mobile */}
              <Element name="cards-scroll-element" />
              {getCurrentCard(navigation)}
            </Grid>
          </Hidden>
          <Hidden smDown>
            <Grid container spacing={16}>
              {/* only desktop */}
              <Grid item md={4} xs={12}>
                <Card number={1} backgroundColor="#fcefeb" color="#d3463d">
                  <FirstQuestion />
                </Card>
              </Grid>
              <Grid item md={8} xs={12}>
                <Card number={2} backgroundColor="#dceff1" color="#4089a1">
                  <SecondQuestion />
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Card
                  number={3}
                  height={185}
                  backgroundColor="#f4fceb"
                  color="#79a942"
                >
                  <ThirdQuestion />
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Card
                  number={4}
                  backgroundColor="#fdf9ea"
                  color="#f6b47e"
                  numberDirection="left"
                >
                  <FourthQuestion />
                </Card>
              </Grid>
            </Grid>
          </Hidden>
          <Grid item xs={12}>
            <Navigation />
          </Grid>
        </form>
      </Container>
    </Grid>
  );
}

Cards.propTypes = {
  getResults: PropTypes.func,
  navigation: PropTypes.number
};

export default reduxForm({
  form: `quiz`,
  initialValues: {
    gender: `male`,
    whom: `boyfriend`,
    age: 24,
    hobby: `animals`
  }
})(
  connect(
    (state) => ({
      navigation: navigationSelector(state)
    }),
    {
      getResults
    }
  )(Cards)
);
